import * as generalPartyInfoServices from '../../services/generalPartyInfoServices';
import {
  CLOSE_CREATE_GENERAL_PARTY_INFO_MODAL,
  OPEN_CREATE_GENERAL_PARTY_INFO_MODAL,
    OPEN_UPDATE_GENERAL_PARTY_INFO_MODAL,
    START_LOADING,
    STOP_LOADING
} from "./actionTypes";


import { FETCH_PRIOR_INSURANCE_CARRIERS_SUCCESS, FETCH_PRIOR_INSURANCE_CARRIERS_FAILURE } from './actionTypes';


export const fetchPriorInsuranceCarriers = () => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'FETCH_PRIOR_INSURANCE_CARRIERS' });
    const token = getState().auth.token ||sessionStorage.getItem("token"); // Adjust based on where you store the token
    const response = await generalPartyInfoServices.getPriorInsuranceCarriers(token);

    dispatch({ type: STOP_LOADING, service: 'FETCH_PRIOR_INSURANCE_CARRIERS' });
    dispatch({ type: FETCH_PRIOR_INSURANCE_CARRIERS_SUCCESS, payload: response });
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'FETCH_PRIOR_INSURANCE_CARRIERS' });
    dispatch({
      type: FETCH_PRIOR_INSURANCE_CARRIERS_FAILURE,
      payload: error.message || 'Failed to fetch prior insurance carriers. Please try again.',
    });
  }
};


export const getAllGeneralPartyInfo = () => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'ALL_GENERAL_PARTY_INFOS' });
    const token = getState().auth.token ||sessionStorage.getItem("token");
    const response = await generalPartyInfoServices.getAllGeneralPartyInfo(token);

    dispatch({ type: STOP_LOADING, service: 'ALL_GENERAL_PARTY_INFOS' });
    dispatch({ type: 'ALL_GENERAL_PARTY_INFOS_SUCCESS', payload: response });
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'ALL_GENERAL_PARTY_INFOS' });
    dispatch({ type: 'ALL_GENERAL_PARTY_INFOS_FAILURE', payload: error.message || 'All GeneralPartyInfos service failed. Please try again.' });
  }
};



export const getGeneralPartyInfoById = (quoteId) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'ALL_GENERAL_PARTY_INFOS' });
    const token = getState().auth.token||sessionStorage.getItem("token");

    const response = await generalPartyInfoServices.getGeneralPartyInfoById(quoteId,token);
    dispatch({ type: STOP_LOADING, service: 'ALL_GENERAL_PARTY_INFOS' });
    dispatch({ type: 'ALL_GENERAL_PARTY_INFOS_SUCCESS', payload: response });
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'ALL_GENERAL_PARTY_INFOS' });
    dispatch({ type: 'ALL_GENERAL_PARTY_INFOS_FAILURE', payload: error.message || 'All GeneralPartyInfos service failed. Please try again.' });
  }
};

export const getGeneralPartyInfoByIdDashboard = (quoteId) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'ALL_GENERAL_PARTY_INFOS' });
    const token = getState().auth.token||sessionStorage.getItem("token");

    const response = await generalPartyInfoServices.getGeneralPartyInfoById(quoteId,token);
    dispatch({ type: STOP_LOADING, service: 'ALL_GENERAL_PARTY_INFOS' });
    dispatch({ type: 'ALL_GENERAL_PARTY_INFOS_DASH_SUCCESS', payload: response });
    return response;
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'ALL_GENERAL_PARTY_INFOS' });
    dispatch({ type: 'ALL_GENERAL_PARTY_INFOS_DASH_FAILURE', payload: error.message || 'All GeneralPartyInfosdash service failed. Please try again.' });
  }
};

export const comparisionResponseById = (gpId) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'ALL_GENERAL_PARTY_INFOS' });
    const token = getState().auth.token||sessionStorage.getItem("token");

    const response = await generalPartyInfoServices.getComparisionById(gpId,token);
    dispatch({ type: STOP_LOADING, service: 'ALL_GENERAL_PARTY_INFOS' });
    dispatch({ type: 'ALL_COMPARISION_SUCCESS', payload: response });
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'ALL_GENERAL_PARTY_INFOS' });
    dispatch({ type: 'ALL_COMPARISION_FAILURE', payload: error.message || 'All Comparision service failed. Please try again.' });
  }
};

export const comparisionResponseCombined = (gpId) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'ALL_GENERAL_PARTY_INFOS' });
    const token = getState().auth.token||sessionStorage.getItem("token");

    const response = await generalPartyInfoServices.getComparisionCombined(gpId,token);
    dispatch({ type: STOP_LOADING, service: 'ALL_GENERAL_PARTY_INFOS' });
    dispatch({ type: 'ALL_COMPARISION_SUCCESS_COMBINED', payload: response });
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'ALL_GENERAL_PARTY_INFOS' });
    dispatch({ type: 'ALL_COMPARISION_FAILURE', payload: error.message || 'All Comparision service failed. Please try again.' });
  }
};

export const getPostGeneralPartyInfoByIdAction = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'ALL_GENERAL_PARTY_INFOS' });
    const token = getState().auth.token||sessionStorage.getItem("token");

    const response = await generalPartyInfoServices.getPostGeneralPartyInfoById(id,token);

    dispatch({ type: STOP_LOADING, service: 'ALL_GENERAL_PARTY_INFOS' });
    dispatch({ type: 'ALL_GENERAL_PARTY_POST_INFOS_SUCCESS', payload: response });
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'ALL_GENERAL_PARTY_INFOS' });
    dispatch({ type: 'ALL_GENERAL_PARTY_INFOS_POST_FAILURE', payload: error.message || 'All GeneralPartyInfos service failed. Please try again.' });
  }
};

export const createGeneralPartyInfo = (formData, callbackfn) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'CREATE_GENERAL_PARTY_INFO' });
    const token = getState().auth.token ||sessionStorage.getItem("token");
    const response = await generalPartyInfoServices.createGeneralPartyInfo(formData, token);
    dispatch({ type: STOP_LOADING, service: 'CREATE_GENERAL_PARTY_INFO' });
    if(response) {
      callbackfn(response.gpId);
    }
    dispatch({ type: 'CREATE_GENERAL_PARTY_INFO_SUCCESS', payload: response });
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'CREATE_GENERAL_PARTY_INFO' });
    dispatch({ type: 'CREATE_GENERAL_PARTY_INFO_FAILURE', payload: error?.body?.message || 'Create GeneralPartyInfo service failed. Please try again.' });
  }
};

export const updateGeneralPartyInfo = (formData, callbackfn) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'UPDATE_GENERAL_PARTY_INFO' });
    const token = getState().auth.token ||sessionStorage.getItem("token");

    const response = await generalPartyInfoServices.updateGeneralPartyInfo(formData, token);
    dispatch({ type: STOP_LOADING, service: 'UPDATE_GENERAL_PARTY_INFO' });
    if(response) {
      callbackfn(response.gpId);
    }
    dispatch({ type: 'UPDATE_GENERAL_PARTY_INFO_SUCCESS', payload: response });
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'UPDATE_GENERAL_PARTY_INFO' });
    dispatch({ type: 'UPDATE_GENERAL_PARTY_INFO_FAILURE', payload: error?.body?.message || 'Update GeneralPartyInfo service failed. Please try again.' });
  }
};

export const openCreateGeneralPartyInfoModal = () => ({
  type: OPEN_CREATE_GENERAL_PARTY_INFO_MODAL,
});

export const closeCreateGeneralPartyInfoModal = () => ({
  type: CLOSE_CREATE_GENERAL_PARTY_INFO_MODAL,
});

export const openUpdateGeneralPartyInfoModal = (id) => async (dispatch) => {
  dispatch({ type:OPEN_UPDATE_GENERAL_PARTY_INFO_MODAL, payload: id });
};


//Zipcode
export const getCityAddress = (zipcode, callbackfn) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'ALL_GENERAL_PARTY_INFOS' });
    const token = getState().auth.token||sessionStorage.getItem("token");
    const response = await generalPartyInfoServices.getCityAndAddressByZipCode(zipcode,token);
    if (response) {
          callbackfn(response); // Pass the random string instead of gpId
        }
    dispatch({ type: STOP_LOADING, service: 'ALL_GENERAL_PARTY_INFOS' });
    dispatch({ type: 'FETCH_CITY_ADDRESS_SUCCESS', payload: response });
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'ALL_GENERAL_PARTY_INFOS' });
    dispatch({ type: 'FETCH_CITY_ADDRESS_FAILURE', payload: error.message || 'Failed to fetch city. Please try again.' });
  }
};

export const getQuoteInfoByFields = (firstName,LastName,dob,cellphone) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'ALL_GENERAL_PARTY_INFOS' });
    const token = getState().auth.token ||sessionStorage.getItem("token");
   const response= await generalPartyInfoServices.getQuoteInfoByFieldServices(firstName,LastName,dob,cellphone,token);
   return response;
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'ALL_GENERAL_PARTY_INFOS' });
    dispatch({ type: 'ALL_QUOTE_INFOS_FAILURE', payload: error.message || 'All Quotefetching service failed. Please try again.' });
  }
};

export const getNewQuoteByGpid = (gpId) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'ALL_GENERAL_PARTY_INFOS' });
    const token = getState().auth.token ||sessionStorage.getItem("token");
   const response= await generalPartyInfoServices.getNewQuoteByGpidServices(gpId,token);
   return response;
    // dispatch({ type: STOP_LOADING, service: 'ALL_GENERAL_PARTY_INFOS' });
    // dispatch({ type: 'ALL_VEHICLE_INFOS_SUCCESS', payload: response });
  } catch (error) {
    dispatch({ type: STOP_LOADING, service: 'ALL_GENERAL_PARTY_INFOS' });
    dispatch({ type: 'ALL_QUOTEBYGPID_INFOS_FAILURE', payload: error.message || 'All Quotefetching service failed. Please try again.' });
  }
};

export const setGpId = (gpId) => ({
  type: "SET_GP_ID",
  payload: gpId,
});

export const clearGpId = () => ({
  type: "CLEAR_GP_ID",
});